import { render, staticRenderFns } from "./MultieditAssembly.vue?vue&type=template&id=1561b561"
import script from "./MultieditAssembly.vue?vue&type=script&lang=ts"
export * from "./MultieditAssembly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports